import React from 'react';

export type UseToggleReturnValue = {
    value: boolean;
    toggle: () => void;
    toggleOn: () => void;
    toggleOff: () => void;
};

export const useToggle = (initialState = false) => {
    const [state, setState] = React.useState(initialState);
    const toggle = React.useCallback(() => {
        setState((prevState) => !prevState);
    }, []);
    const toggleOn = React.useCallback(() => {
        setState(true);
    }, []);
    const toggleOff = React.useCallback(() => {
        setState(false);
    }, []);
    return {
        value: state,
        toggle,
        toggleOn,
        toggleOff,
    };
};
